<template>
    <section
        class="ProductHero"
        :class="{ 'ProductHero--simple' : !images.length }"
    >
        <div class="ProductHero__container container relative">
            <div class="grid">
                <div
                    :class="{ 'lap-and-up-one-half' : images.length }"
                    class="grid__item ProductHero__title-padding"
                >
                    <BreadCrumbs
                        v-if="category"
                        :items="[category]"
                        :current="heading"
                    />
                    <BaseHeading
                        :heading="heading"
                        tag="h1"
                    />
                    <MetaData
                        v-if="tags"
                        :tags="tags"
                    />
                </div>
                <div
                    class="grid__item"
                    :class="{ 'lap-and-up-one-half' : images.length }"
                >
                    <PageBuilderImages
                        :images="images"
                        class="PageBuilderImages--nav-inner"
                    />
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: 'ProductHero',
    props: {
        heading: {
            type: String,
        },
        images: {
            type: Array,
            default: null
        },
        tags: {
            type: Array,
            default: null
        },
        category: {
            type: Object,
            default: null
        },
    }
}
</script>
<style lang="scss" scoped>
    .ProductHero {
        overflow: hidden;
    
        @include media-query(lap-and-up) {
            padding-top: getSpacing(medium);
            padding-bottom: getSpacing(min);
        }
    }

    .ProductHero__title-padding {
        @include media-query(lap-and-up){
            padding-bottom: getSpacing(medium);
        }
    }

    .ProductHero__container {

         @include media-query(lap-and-up) {

            &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: getSpacing(medium);
                height: 1px;
                width: 100%;
                border-bottom: 1px solid getColour('grey', 'medium');
                z-index: -1;

                .ProductHero--simple & {
                    bottom: 0;
                }
            }
        }
    }

    .BaseHeading {
        @include media-query(lap-and-up) {
            padding-right: getSpacing(medium);
        }
    }
    .MetaData {
        margin-top: getSpacing(base);

        @include media-query(lap-and-up) {
            margin-top: getSpacing(medium);
        }
    }

    .PageBuilderImages {
        position: relative;
        padding-top: getSpacing(small);

        ::v-deep .flickity-enabled {
            transform: rotate(1deg);
            background-image: linear-gradient(-174deg, rgba(0,0,0,0.00) 74%, rgba(0,0,0,0.40) 100%);
        }

        @include media-query(palm) {
            padding-top: getSpacing(spacer);
        }

        > ::v-deep .BaseImage {
            transform: rotate(1deg);
        }
    }
</style>
